<template>
  <div class="CounterContainer">
    {{value}}<slot></slot>
  </div>
</template>

<script>

//import component from '@assets/components/component.vue'
import { eventBus } from '@/utils'

export default {
  name: 'CounterContainer',
  components: {
    //component
  },
  props: {
    start: Number,
    end: Number,
    delay: {type: Number, default: 0},
    speed: Number,
    elref: {default: null},
  },
  data: function () {
    return {
      value: Number
    }
  },
  computed: {
  },
  methods: {
    setCallbacks: function () {
    },
    onScroll: function (scrollTop) {
      this.value = Math.floor(Math.max(this.start,Math.min(this.end,(window.innerHeight - this.elref.$el.getBoundingClientRect().top)*this.speed - this.delay*this.speed*window.innerHeight/100)))
    },
  },
  created: function () {
    eventBus.$on('scroll',(e) => {
      this.onScroll(e.srcElement.scrollTop)
    });
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.CounterContainer{
}

</style>
